// ** React Imports
import { useEffect, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadActivityStore, ViewType, LeadAccountStore, LeadCompanyStore, SprintDialogStore, LeadSprintStore, LeadActivityHistoryStore, HistoryDetailsDialogStore, ActivityHistoryDialogStore } from 'src/stores/LeadStore';
import { leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import _ from 'lodash';
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import MuiTimeline, { TimelineProps } from '@mui/lab/Timeline'
import TimelineDot from '@mui/lab/TimelineDot'
import TimelineItem from '@mui/lab/TimelineItem'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import Icon from 'src/features/common/CustomIcon'
import { previousDateDays } from 'src/utils/date-utils';
import Link from '@mui/material/Link';

import IconButton from '@mui/material/IconButton';

// Styled Timeline component
const Timeline = styled(MuiTimeline)<TimelineProps>(({ theme }) => ({
    margin: 0,
    padding: 0,
    marginLeft: theme.spacing(0.75),
    '& .MuiTimelineItem-root': {
        '&:before': {
            display: 'none'
        },
        '&:last-child': {
            minHeight: 60
        }
    }
}))

type Props = {
    activityHistorDialogMode: boolean,
    miHistorDialogMode: boolean
}



const ActivityHistoryList = ({ activityHistorDialogMode, miHistorDialogMode }: Props) => {
    var activites = LeadActivityHistoryStore.useState(s => s.record.activities);
    if (miHistorDialogMode == true) {
        activites = LeadActivityHistoryStore.useState(s => s.record.miActivities);
    }

    const viewLeads = (activityId: string) => {
        HistoryDetailsDialogStore.update(s => { s.historyDetailsDialogStore = true })
        HistoryDetailsDialogStore.update(s => { s.activityId = activityId })
    };
   
    return <Card sx={{ mb: 6 }} data-testid="activity-timeline">
        <CardContent>
            <Timeline>
                {activites.map(record => (
                    <TimelineItem key={record.id} >
                        {!record.isAction &&
                            <TimelineSeparator>
                                <Tooltip title={record.currentActivityName} >
                                    <TimelineDot variant="outlined" >
                                        <Icon icon={record.currentActivityOutcomeIcon} sx={{ color: 'CornflowerBlue', fontSize: 20 }} ></Icon>
                                    </TimelineDot>
                                </Tooltip>
                                <TimelineConnector />
                            </TimelineSeparator>
                        }
                        {record.isAction &&
                            <TimelineSeparator>
                                <Tooltip title={record.actionActivityName} >
                                    <TimelineDot variant="outlined" >
                                        <Icon icon={"assistant_photo_two_tone"} sx={{ color: 'CadetBlue', fontSize: 20 }} ></Icon>
                                    </TimelineDot>
                                </Tooltip>
                                <TimelineConnector />
                            </TimelineSeparator>
                        }
                        {!record.isAction &&
                            <TimelineContent>
                                <Typography variant='body2' sx={{ mr: 1 }}>
                                    <Link
                                        underline="hover"
                                        component="button"
                                        variant="body2"
                                        onClick={() => viewLeads(record.leadId)}
                                    >
                                        {record.currentActivityOutcomeName}
                                    </Link>
                                    {record.currentActivityOutcomeName != '' && record.currentActivityHasMi &&
                                        <Tooltip title="Meaningful Interaction">
                                            <QuestionAnswerTwoToneIcon sx={{ color: 'LightSeaGreen' }} />
                                        </Tooltip>
                                    }
                                </Typography>
                                <Typography variant='caption'>{previousDateDays(record.currentActivityDate)} by {record.currentActivityOwnerName}</Typography>
                            </TimelineContent>
                        }
                        {record.isAction &&
                            <TimelineContent>
                                <Typography variant='body2' sx={{ mr: 1 }}>
                                    <Link
                                        underline="hover"
                                        component="button"
                                        variant="body2"
                                        onClick={() => viewLeads(record.leadId)}
                                    >
                                        {record.actionActivityName}
                                    </Link>
                                </Typography>
                                <Typography variant='caption'>{previousDateDays(record.currentActivityDate)} by {record.currentActivityOwnerName}</Typography>
                            </TimelineContent>
                        }
                    </TimelineItem>
                ))
                }
            </Timeline>
        </CardContent>
    </Card>
}

export { ActivityHistoryList }

export default ActivityHistoryList;